import React, { useState } from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';
import { FidemChat } from './FidemChat';

const SUGGEST = ['Redacta los descargos de mi causa activa', '¿Qué ministro de mi causa activa conviene más y cómo le alego?', '¿Qué fallos recientes contradicen la doctrina de mis causas?', '¿Cuál es mi tasa de éxito con este tribunal?', '¿Qué estrategia recomienda Cerebro para mi causa activa?'];

// Fidem embedded inside Cerebro (Inteligencia Judicial), sharing the active case
export const CerebroFidem = () => {
  const [open, setOpen] = useState(true);
  return (
    <section data-testid="cerebro-fidem" className="mb-6 rounded-2xl border border-amber-500/30 bg-slate-900/40 p-4">
      <button data-testid="cerebro-fidem-toggle" onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 text-left">
        <Sparkles className="h-5 w-5 text-amber-400" />
        <span className="font-semibold text-white">Fidem en Cerebro</span>
        <span className="hidden text-xs text-slate-400 sm:inline">pregunta sobre jueces, fallos y estrategia sin salir de aquí</span>
        <ChevronDown className={`ml-auto h-4 w-4 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <FidemChat height="h-[40vh]" suggest={SUGGEST} />}
    </section>
  );
};
